import React from 'react';
import { Check } from 'lucide-react';

export default function SuccessModal({ show, onClose }) {
  if (!show) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full text-center border-t-8 border-green-500 animate-scale-in">
        <Check className="w-12 h-12 text-green-500 mx-auto mb-4 animate-bounce" />
        <h4 className="text-xl font-bold mb-2 text-gray-800">Message Sent!</h4>
        <p className="text-gray-600">Thank you for reaching out. We will connect with you soon.</p>
        <button
          onClick={onClose}
          className="mt-6 bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-xl transition-colors"
        >
          Close
        </button>
      </div>
    </div>
  );
}